/* eslint-disable quotes */
/* eslint-disable react/display-name */
/* eslint-disable no-prototype-builtins */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { Fragment, memo, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getAuthSession } from "../Helpers/common";
import {
  setChatboardSelectedTab,
  setLoaderMorePinnedChat,
  setPinnedChatMessage,
} from "../redux/chatSlice";
import {
  _sendChatRoomPinnedMessage,
  _sendLoadMoreChatRoomPinnedMessage,
} from "../../SocketIo";
import { alertMsg } from "../util/alertMsg";
import ChatboardPinnedIncoming from "../chatboard/chatboardPinnedIncoming";
import ChatboardPinnedOutgoing from "../chatboard/chatboardPinnedOutgoing";
import { getPinnedData } from "../Helpers/chatCommon";
import CustomChatLoader from "../customComponent/customChatLoader";

const PinnedMessages = ({ handlePinnedMessage, handleJumpToMessage }) => {
  const dispatch = useDispatch();
  const {
    attendeeData,
    chatRoom,
    pinnedChatMessages,
    loaderPinnedChatData,
    loaderMorePinnedChatMessage,
    chatboardSelectedTab,
    hasMorePinnedChatMessage,
  } = useSelector((state) => state.chat);

  const authSessionUser = useSelector(
    (state) => state.authUserDetail.authSessionUser,
  );
  const authSession = getAuthSession();
  const [pinnedMessages, setPinnedMessage] = useState([]);
  const [pinnedActionsId, setPinnedActionId] = useState("");
  const chatFeedRef = useRef(null);

  let companyID = attendeeData?.company_id;
  let senderID = authSession?.user_unique_key;

  if (attendeeData?.type === "group") {
    companyID = authSession?.company_unique_key;
  }

  let incomingUserObj = attendeeData;
  let outgoingUserObj = authSessionUser;

  useEffect(() => {
    if (chatboardSelectedTab === "pins" && chatRoom) {
      const pinnedData = getPinnedData(chatRoom);
      if (pinnedData.length > 0) {
        dispatch(setPinnedChatMessage(pinnedData));
      } else {
        _sendChatRoomPinnedMessage({
          company_id: companyID,
          documentID: chatRoom,
          user_id: senderID,
        });
      }
    }
  }, [chatboardSelectedTab]);

  useEffect(() => {
    setPinnedMessage(pinnedChatMessages);
  }, [pinnedChatMessages]);

  const handleScroll = () => {
    if (
      !chatFeedRef.current ||
      loaderMorePinnedChatMessage ||
      !hasMorePinnedChatMessage
    )
      return;
    const { scrollTop, scrollHeight, clientHeight } = chatFeedRef.current;
    if (scrollTop + clientHeight >= scrollHeight - 20) {
      loadMorePinnedMessages();
    }
  };

  const loadMorePinnedMessages = () => {
    if (pinnedChatMessages.length === 0) return;
    dispatch(setLoaderMorePinnedChat(true));
    const lastMessage = pinnedChatMessages[pinnedChatMessages.length - 1];
    if (lastMessage) {
      _sendLoadMoreChatRoomPinnedMessage({
        company_id: companyID,
        documentID: chatRoom,
        user_id: senderID,
        timestamp: lastMessage.pinned_timestamp,
      });
    }
  };

  const handleUnpinMessage = (value) => {
    if (pinnedMessages.length === 1) {
      dispatch(setChatboardSelectedTab("messages"));
      handlePinnedMessage(value);
    } else {
      setPinnedMessage((prev) =>
        prev.filter((message) => message.id !== value.id),
      );
      handlePinnedMessage(value);
    }
  };

  const pinnedActionHandler = (id) => {
    setPinnedActionId(id);
  };

  return (
    <div
      className={`chat_box pinned-msg ${
        pinnedMessages.length === 0 ? "no-msg" : ""
      }`}
    >
      <div className="body body-inner">
        {loaderPinnedChatData ? (
          <CustomChatLoader />
        ) : pinnedMessages.length === 0 ? (
          <PinnedChatMessageNotFound />
        ) : (
          <div
            id="chat-feed"
            className={`chat-feed ${
              pinnedMessages.length >= 3 ? "overflow-auto" : ""
            }`}
            ref={chatFeedRef}
            onScroll={handleScroll}
          >
            <div>
              {pinnedMessages.map((value, index) => {
                return (
                  <Fragment key={index}>
                    {value.senderID === senderID ? (
                      <ChatboardPinnedOutgoing
                        value={value}
                        userInfo={outgoingUserObj}
                        lastMessage={
                          pinnedChatMessages.length - 1 === index ? true : false
                        }
                        handleJumpToMessage={handleJumpToMessage}
                        handleUnpinMessage={handleUnpinMessage}
                        pinnedActionHandler={pinnedActionHandler}
                        pinnedActionsId={pinnedActionsId}
                        setPinnedActionId={setPinnedActionId}
                      />
                    ) : (
                      <ChatboardPinnedIncoming
                        value={value}
                        userInfo={incomingUserObj}
                        lastMessage={
                          pinnedChatMessages.length - 1 === index ? true : false
                        }
                        handleJumpToMessage={handleJumpToMessage}
                        handleUnpinMessage={handleUnpinMessage}
                        pinnedActionHandler={pinnedActionHandler}
                        pinnedActionsId={pinnedActionsId}
                        setPinnedActionId={setPinnedActionId}
                      />
                    )}
                  </Fragment>
                );
              })}
              {/* Loader at bottom */}
            </div>
            {loaderMorePinnedChatMessage && <CustomChatLoader />}
          </div>
        )}
      </div>
    </div>
  );
};

export default memo(PinnedMessages);

const PinnedChatMessageNotFound = () => {
  return (
    <p className="text-center">
      <b>{alertMsg.nothingPinned}</b>
      <br />
      {alertMsg.msgPinnedNotFound}
      <br />
    </p>
  );
};
